import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  device_states: [],
  device_state: {},
  device_list_view: {},
  device_revisions: [],
  device_revisions_view: {},
  profile_revisions: [],
  profile_revisions_view: {},
  operations: [],
  operations_view: {},
  operation_devices: [],
  operation_devices_view: {},
  operation_status: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/modules/endDeviceStates/store/index.js